import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'md', text = null }) => {
    const sizeClass = `spinner-${size}`;

    return (
        <div className="loading-spinner-container">
            <div className={`spinner ${sizeClass}`}></div>
            {text && <p className="spinner-text">{text}</p>}
        </div>
    );
};

export default LoadingSpinner;
